import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Logo from "./Core/Logo";
import GradientButton from "./Core/GradientButton";
import FileUploadBlock from "./Registration/Steps/FileUploadBlock";
import { useSessionStore } from "../Stores/SessionStore";

export default function Resubmit() {
	const navigate = useNavigate();
	const params = useParams();
	const store = useSessionStore();

	const [submitted, setSubmitted] = useState(false);
	const [submitting, setSubmitting] = useState(false);
	const [documents, setDocuments] = useState({ IDDocument: null, ServiceIDDocument: null });

	function handleIDUploaded(file, fileName) {
		setDocuments((current) => ({
			...current,
			IDDocument: file ? { Content: file, FileName: fileName } : null,
		}));
	}

	function handleServiceIDUploaded(file, fileName) {
		setDocuments((current) => ({
			...current,
			ServiceIDDocument: file ? { Content: file, FileName: fileName } : null,
		}));
	}

	async function handleContinueClicked() {
		if (!documents.IDDocument || !documents.ServiceIDDocument) {
			return;
		}

		setSubmitting(true);
		const result = await store.CustomersService.ResubmitCustomerDocument(params.customerId, documents);
		setSubmitting(false);

		if (result && result.Success) {
			setSubmitted(true);
		}
	}

	function handleGoToPortal() {
		if (store.UserIsLoggedIn) {
			navigate("/Portal/Home");
			return;
		}

		navigate("/");
	}

	return (
		<Container fluid>
			<div className="p-2 p-md-4">
				<Row className="d-flex align-items-center my-4 mb-5">
					<Col xs={12} md={8} lg={7}>
						<Logo />
					</Col>
				</Row>
				<Row className="justify-content-center">
					<Col xs={12} lg={8}>
						<div className="portal-resubmit-card">
							<h4 className="text-center mb-4">Upload documentation for RICA purposes:</h4>
							{!submitted ? (
								<>
									<p className="text-center mb-4">
										We require the following documentation to be re-uploaded in order to adhere to the RICA Act 70 of 2002.
									</p>
									<div className="mb-4">
										<FileUploadBlock
											filename={documents.IDDocument?.FileName ?? null}
											file={documents.IDDocument?.Content ?? null}
											onFileChanged={handleIDUploaded}
											name="IdBook"
											description="ID Book or Card / Foreign Passport"
										/>
									</div>
									<div className="mb-4">
										<FileUploadBlock
											filename={documents.ServiceIDDocument?.FileName ?? null}
											file={documents.ServiceIDDocument?.Content ?? null}
											onFileChanged={handleServiceIDUploaded}
											name="ServiceID"
											description="Service ID Picture"
										/>
									</div>
									<GradientButton
										title={submitting ? "Submitting..." : "Submit"}
										variant="greenYellow"
										onClick={handleContinueClicked}
										disabled={submitting || !documents.IDDocument || !documents.ServiceIDDocument}
										loading={submitting}
									/>
								</>
							) : (
								<>
									<h4 className="portal-resubmit-success mb-4">Thank you for uploading your documents.</h4>
									<GradientButton title="Go To Portal" variant="greenYellow" onClick={handleGoToPortal} />
								</>
							)}
						</div>
					</Col>
				</Row>
			</div>
		</Container>
	);
}
